import type { FC, ReactNode } from 'react';
import { Box, Grid } from '@mui/material';

import type {
  DashboardWidgetConfig,
  GridSizeOrGrow,
} from 'src/types/dashboard';
import { getWidgetId } from 'src/components/dashboard/DashboardPage/components/WidgetWrapper/helper';
import { WIDGET_WRAPPER_TEST_ID } from 'src/components/dashboard/DashboardPage/components/WidgetWrapper/index';
import useWidgetChartConfig from 'src/components/dashboard/hooks/useWidgetChartConfig';

import WidgetHashLink from './widgetHashLink';

import { styles } from './widgetGridWrapper.styles';

// helper to convert GridSize to what Grid component accepts
const toGridProp = (size: GridSizeOrGrow): boolean | 'auto' | number => {
  if (size === 'grow') return true;
  return size;
};

interface WidgetGridWrapperProps {
  config: DashboardWidgetConfig;
  gridSize: GridSizeOrGrow;
  className: string;
  children: ReactNode;
}

const WidgetGridWrapper: FC<WidgetGridWrapperProps> = ({
  config,
  gridSize,
  className,
  children,
}) => {
  const { id, internal_link } = config;
  const widgetId = getWidgetId(id);
  const { backgroundColor, fontWeight, fontSize } =
    useWidgetChartConfig(config);

  return (
    <Grid
      item
      xs={12}
      lg={toGridProp(gridSize)}
      sx={styles.widgetContainer}
      className={className}
      data-test-id={WIDGET_WRAPPER_TEST_ID}
      id={widgetId}
    >
      <Box sx={styles.widget(backgroundColor, fontWeight, fontSize)}>
        <WidgetHashLink internalLink={internal_link}>{children}</WidgetHashLink>
      </Box>
    </Grid>
  );
};
export default WidgetGridWrapper;
